module.exports = __webpack_public_path__ + "static/media/mpfa logo.41de40dd.png";